define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ContentImportErrorsController = require('content-controllers/ContentImportErrorsController');
    var ContentSystemTabsLayout = require('content-views/content-gallery/system/ContentSystemTabsLayout');
    var ContentSystemTableController = require("content-controllers/system/ContentSystemTableController");
    var Constant = require("content-config/constant.json");

    var TYPES = Constant.CONTENT_TYPES;

    var TABS = {
        CHAT: TYPES.SYSTEM,
        MESSAGING: TYPES.SYSTEM_MESSAGING
    };

    var TABS_MAP = {};
    TABS_MAP[TABS.CHAT] = {
        dictionaryKey: "chat",
        ctrlParameters: {type: TYPES.SYSTEM},
        ViewController: ContentSystemTableController,
        isEnabled: function() {
            return LE.sessionManager.hasMessagingAutoMessagesFeature(); //todo not bom
        }
    };
    TABS_MAP[TABS.MESSAGING] = {
        dictionaryKey: "messaging",
        ctrlParameters :{type: TYPES.SYSTEM_MESSAGING},
        ViewController: ContentSystemTableController,
        isEnabled: function() {
            return LE.sessionManager.hasMessagingAutoMessagesFeature();
        }
    };

    var ADDITIONAL_PAGE_CLASS_NAME = "system-messages-tabs-page";

    var ContentSystemTabsController = {};

    function moduleDefinition(LEContent, LE, Backbone, Marionette, $, _) {
        ContentSystemTabsController = Marionette.Controller.extend({
            pageView: null,
            tabsLayout: null,
            insideView: null,
            selectedTabId: null,

            initialize: function(options) {
                this._initialize(options);
            },

            getMainView: function() {
                return this._getView();
            },

            showChatTab: function() {
                this._showChatTab();
            },

            showMessagingTab: function() {
                this._showMessagingTab();
            },

            getFirstTabPath: function() {
                return _getFirstTabPath();
            },

            _initialize: function(options) {
                LEContent.logger.info("initializing", "ContentSystemTabsController:initialize");
                this.channel = LEContent.media.channel("contentSystemTabs");

                _.each(TABS,function(tabConfig){
                    var config = TABS_MAP[tabConfig];
                    config.viewController = new config.ViewController(config.ctrlParameters);
                },this);

                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.channel, "contentSystemTabs:page:close", this._onCloseClick);
                this.listenTo(this.channel, "contentSystemTabs:tab:change", this._onHeaderTabsChange);
                this.listenTo(this.channel, "paging:clear:AllSelection", this._onClearSelection);
                this.listenTo(this.channel, "contentSystemTabs:change:page", this._pageChange, this);
                this.listenTo(this.channel,"contentSystemTabs:buttons:done",this._done);
            },

            _getView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function () {
                if (!this.pageView) {
                    this.pageView = new Page({
                        moduleName: LEContent.moduleName,
                        context: LE.context,
                        permutation: Page.PERMUTATION.Dialog,
                        isPermanent: true,
                        additionalClassName: ADDITIONAL_PAGE_CLASS_NAME,
                        header: {
                            title: LE.translator.translate("LEContent.content.gallery.system.title"),
                            description: LE.translator.translate("LEContent.content.gallery.system.description")
                        }
                    });
                    this._bindEventsPage();
                }
            },

            _bindEventsPage: function() {
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _pageChange: function (currentPageNumber) {
                this._getPageModel().pageNumberChange(currentPageNumber);
            },

            _onPageClose: function() {
                if (this.pageView) {
                    this.stopListening(this.pageView);
                }
                this.pageView = null;
            },
            _onClearSelection: function() {
                TABS_MAP[this.selectedTabId].viewController.channel.trigger("paging:clear:AllSelection");
            },

            _showChatTab: function() {
                this.selectedTabId = TABS.CHAT;
                this._showView();
            },

            _showMessagingTab: function() {
                this.selectedTabId = TABS.MESSAGING;
                this._showView();
            },

            _showView: function(viewOptions) {
                this.insideView = TABS_MAP[this.selectedTabId].viewController.getMainView();
                if (_.isFunction(TABS_MAP[this.selectedTabId].viewController.prepData)) {
                    TABS_MAP[this.selectedTabId].viewController.prepData();
                }

                if (_.isEmpty(this.pageView.getInsideView())) {
                    this.tabsLayout = new ContentSystemTabsLayout({tabs:_getHeaderTabsArr(), selectedTab:this.selectedTabId, tablePageModel: this._getPageModel(), channel: this.channel});
                    this.listenToOnce(this.tabsLayout, "render", _.bind(function(){
                         this.tabsLayout.selectedTabRegion.add(this.insideView);
                    },this));
                    this.pageView.setInsideView(this.tabsLayout);
                }
                else {
                    this.tabsLayout.setSelectedTab(this.selectedTabId);
                    //if the current view is already rendered do not rerender - will create a problem
                    if (this.tabsLayout.selectedTabRegion.currentView !== this.insideView) {
                        this.tabsLayout.selectedTabRegion.add(this.insideView);
                    }

                }

                this.tabsLayout.setPageModel(this._getPageModel());
            },
            _getPageModel: function() {
               return   TABS_MAP[this.selectedTabId].viewController.getPageModel();
            },

            _onHeaderTabsChange: function(selectedTabId) {
                var path = TABS_MAP[selectedTabId].viewController.getPath();

                LEContent.router.navigateNonBackable(path);
            },

            _done: function(){
                LEContent.router.navigateBack();
            },

            _onCloseClick: function() {
                LEContent.router.navigateBack();
            }
        });

        function _getHeaderTabsArr() {
            var tabsArr = [];
            _.each(TABS, function(tab) {
                if(TABS_MAP[tab].isEnabled()) {
                    var tabItem = {
                        id: tab,
                        name: LE.translator.translate("LEContent.content.system.tab." + TABS_MAP[tab].dictionaryKey + ".title")
                    };

                    tabsArr.push(tabItem);
                }
            });
            return tabsArr;
        }

        function _getFirstTabPath() {
            var path = TABS_MAP[TABS.CHAT].viewController.getPath(); //use a default for those who has no permissions at all
            var tabsArr = _getHeaderTabsArr();
            if (tabsArr[0]) {
                path = TABS_MAP[tabsArr[0].id].viewController.getPath();
            }
            return path;
        }
    }

    LE.module("LEContent", moduleDefinition);

    return  ContentSystemTabsController;
});
